import { GET_PORTAL_ORGANISATIONType } from '../../../graphql/queries/GetPortalOrganisation';

/**
 * The logo an organisation uploaded on its own profile, if it has one.
 *
 * A portal organisation is either a service provider or a funder - institutions
 * have no profile logo - so whichever of the two is present carries the logo.
 * Anything that is not a stored URL (an empty column, or the C:\fakepath value
 * a file input reports before the upload finishes) counts as "not uploaded", so
 * the caller falls back to the ImpactBoard logo.
 */
export const organisationLogo = (portalOrganisation: GET_PORTAL_ORGANISATIONType): string | undefined => {
  const organisation = portalOrganisation && portalOrganisation.organisation;

  if (!organisation) {
    return undefined;
  }

  const uploaded = [organisation.serviceProvider, organisation.funder]
    .map(entity => (entity && entity.logo) || '')
    .find(logo => logo.indexOf('http') === 0);

  return uploaded || undefined;
};

export default organisationLogo;
